import dayjs from 'dayjs';
import { array, date, DateSchema, object, ref, SchemaOf } from 'yup';

import { getDateWithProperTimeOffset } from '@/utils/date.utils';
import { DateRangeAndInterval } from './hooks/useDownloadUpliftTemplate';

export const errorMessages = {
  atLeastOneRequired: 'At least one field in the date range must be specified',
  dateLessThanTomorrow: 'Date cannot be less than tomorrow',
  dateLessThanStartDate: 'End date cannot be less than start date'
};

export const initialValues: DateRangeAndInterval = {
  dateFrom: null,
  dateTo: null,
  billingIntervals: undefined
};

const tomorrowWithTimeOffset = dayjs(getDateWithProperTimeOffset(new Date())).add(1, 'day').startOf('day');

export const validationSchema: SchemaOf<DateRangeAndInterval> = object().shape({
  dateFrom: date()
    .min(tomorrowWithTimeOffset, errorMessages.dateLessThanTomorrow),
  dateTo: date()
    .when('dateFrom', {
      is: (dateTo: any) => dayjs(dateTo ?? null).isValid(),
      then: (schema: DateSchema) => {
        return schema.min(
          ref('dateFrom'), errorMessages.dateLessThanStartDate
        );
      },
      otherwise: (schema: DateSchema) => schema.min(
        tomorrowWithTimeOffset,
        errorMessages.dateLessThanTomorrow
      ).required(errorMessages.atLeastOneRequired),
    }),
  billingIntervals: array()
    .optional()
});
